<template>
  <v-select
    :light="landingPage"
    class="country-code"
    :items="indiaCountryCode"
    item-text="code"
    item-value="dial_code"
    outlined
    dense
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #item="data">
      {{ data.item.code }} - {{ data.item.name }} ({{
        '+' + data.item.dial_code
      }})
    </template>
  </v-select>
</template>

<script>
import indiaCountryCode from '@/assets/country-codes/indiaCountryCode.json'

export default {
  props: {
    landingPage: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      // countryCodes: CountryCodesJson,
      indiaCountryCode
    }
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>
